import cs from 'classnames';
import React from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import { injectStoresV2 } from '../../stores/injectStoresV2';
import { Search } from '../Search/Search';
import { HeaderStore } from '../../stores/HeaderStore';
import { RoutingStore } from '../../stores/RoutingStore';
import { headerTitleDataHooks } from './HeaderTitle.dataHooks';
import styles from './HeaderTitle.scss';

type HeaderTitleProps = {
  dataHook?: string;
  headerStore: HeaderStore;
  routingStore: RoutingStore;
};

const HeaderTitleCmp: React.FC<HeaderTitleProps> = ({ dataHook, headerStore, routingStore }) => {
  const { t } = useTranslation();
  const HeadingTagName = routingStore.matchedRoute?.routeName === 'home' ? 'h1' : 'div';

  return (
    <div className={styles.header} data-hook={dataHook}>
      <HeadingTagName
        className={cs(styles.title, headerStore.isSearchInputFocused && styles.smallText)}
        data-hook={headerTitleDataHooks.title()}
        children={t('header.title.v2')}
      />
      {!headerStore.isSticky && <Search dataHook={headerTitleDataHooks.search()} />}
    </div>
  );
};

export const HeaderTitle = injectStoresV2('headerStore', 'routingStore')(HeaderTitleCmp);
